import { useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { supabase } from "./supabase";
import "./App.css";
import { useSelector } from "react-redux";
import Header from "./components/header/Header.jsx";
import Home from "./components/home/Home.jsx";
import About from "./components/about/About.jsx";
import Skills from "./components/skills/Skills.jsx";
import Qualifications from "./components/qualifications/Qualifications.jsx";
import Contact from "./components/contact/Contact.jsx";
import Footer from "./components/footer/Footer.jsx";
import Scroll from "./components/scroll/ScrollToTop.jsx";
import Projects from "./components/projects/Projects";
import GitHubStats from "./components/githubStats/GitHubStats";
import Courses from "./components/courses/Courses";
import AdminPanel from "./components/admin/AdminPanel";
import { useScrollReveal } from "./hooks/useScrollReveal";
import Testimonials from "./components/testimonials/Testimonials";
import CurrentlyWorking from "./components/currentlyworking/CurrentlyWorking";
import FAQ from "./components/faq/FAQ";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import OrionOs from "./components/orion/OrionOs.jsx";

function App() {
  const [session, setSession] = useState(null);
  const [showAdmin, setShowAdmin] = useState(false);
  const isDark = useSelector((state) => state.darkMode);

  useScrollReveal(".reveal");

  // Apply dark mode class on mount and when isDark changes
  useEffect(() => {
    if (isDark) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [isDark]);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (!session) setShowAdmin(false);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header
                session={session}
                onAdminClick={() => setShowAdmin(true)}
              />
              <Home />
              <About />
              <Skills />
              <GitHubStats />
              <Projects />
              {false && <Courses />}
              <Testimonials />
              <CurrentlyWorking />
              <Qualifications />
              <Contact />
              <FAQ />
              <Footer />
              <Scroll />
              <Analytics />
              <SpeedInsights />
              {showAdmin && session && (
                <AdminPanel
                  onLogout={() => setShowAdmin(false)}
                  onClose={() => setShowAdmin(false)}
                />
              )}
            </>
          }
        />
        <Route path="/orion-os" element={<OrionOs />} />
      </Routes>
    </Router>
  );
}

export default App;
